var apiFilters = {
  filters: [],
  filtersSelect: [],
  apiFiltersJsData: apiFiltersJsData,
  //  data from wordpress localize script
  isLoading: true,
  init: function init() {
    this.initFilters();
    this.initResetBtn();
  },
  initFilters: function initFilters() {
    var _this = this;
    this.filters = [];
    var filters = document.querySelectorAll("input.apiFilter");
    if (filters.length > 0) {
      filters.forEach(function (filter) {
        /* get data-id */
        var filterId = filter.getAttribute("data-id");
        var maxValues = filter.getAttribute("data-max-values") || 1;
        _this.filters.push(filterId);
        /* init tom select library */
        var filterOptions = _this.getFilterOptions(filterId);
        _this.filtersSelect[filterId] = new TomSelect("#filter-".concat(filterId), {
          maxItems: maxValues,
          closeAfterSelect: true,
          valueField: "value",
          labelField: "label",
          searchField: "label",
          options: filterOptions.values,
          items: filterOptions.selected,
          create: false,
          placeholder: filterOptions.placeholder || filterOptions.label,
          hidePlaceholder: true,
          plugins: {
            checkbox_options: [],
            remove_button: {
              title: "Remove this item"
            }
          },
          onChange: function onChange(value) {
            return _this.updateUrl("".concat(filterOptions.postType, "_").concat(filterId), value);
          }
        });
        _this.filtersSelect[filterId].on("initialize", function () {
          _this.filtersSelect[filterId].input.setAttribute("size", _this.filtersSelect[filterId].input.getAttribute("placeholder").length);
        });
        if (filterOptions.values.length === 0) {
          _this.filtersSelect[filterId].disable();
        }
      });
    }
  },
  initResetBtn: function initResetBtn() {
    var _this2 = this;
    var resetBtn = document.querySelector(".resetApiFilters");
    if (resetBtn) {
      resetBtn.addEventListener("click", function () {
        _this2.resetFilters();
      });
    }
  },
  getFilterOptions: function getFilterOptions(filterId) {
    var filterOptions = [];
    var filter = this.apiFiltersJsData.filtersSettings[filterId];
    if (filter) {
      filterOptions = filter;
    }
    return filterOptions;
  },
  updateUrl: function updateUrl(filterId, filterValue) {
    this.loadingState();
    console.log("filter ".concat(filterId, " changed to ").concat(filterValue));
    var url = new URL(window.location.href);
    var params = new URLSearchParams(url.search);
    params.delete("trainings_page");
    params.set(filterId, filterValue);
    /* if filterValue is empty, remove param */
    if (filterValue === "") {
      params.delete(filterId);
    }
    url.search = params.toString();
    window.history.pushState({}, "", url.toString());
    var currentLanguage = this.getCurrentLanguage("wp-wpml_current_language");

    /* Redirect to campus/formations if trainings_region filters are empty */
    if (("trainings_region" === filterId || "trainings_type" === filterId || "trainings_theme" === filterId) && "" === filterValue && "" !== currentLanguage) {
      var location = "/formations/";
      if ("en" === currentLanguage) {
        location = "/en/trainings/";
      } else if ("es" === currentLanguage) {
        location = "/es/formacions/";
      }
      window.location.href = window.location.origin + location;
    } else {
      window.location.reload();
    }
  },
  resetFilters: function resetFilters() {
    var _this3 = this;
    this.filters.forEach(function (filterId) {
      _this3.filtersSelect[filterId].clear(true);
      _this3.filtersSelect[filterId].disable();
    });
    var url = new URL(window.location.href);
    window.location.href = url.origin + url.pathname;
  },
  loadingState: function loadingState() {
    var _this4 = this;
    this.isLoading = true;
    this.filters.forEach(function (filterId) {
      _this4.filtersSelect[filterId].disable();
    });
    /* add a spinner here */
    setTimeout(function () {
      _this4.isLoading = false;
      _this4.filters.forEach(function (filterId) {
        _this4.filtersSelect[filterId].enable();
      });
      /* disable the spinner here */
    }, 10000);
  },
  getCurrentLanguage: function getCurrentLanguage(name) {
    if (window.location.href.indexOf("/es/") > -1) {
      return "es";
    }
    if (window.location.href.indexOf("/en/") > -1) {
      return "en";
    }
    return "fr";
  }
};
vtxDomReady(apiFilters.init());